import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import LegalPage from "./LegalPage";
import Marketplace from "./Marketplace";
import "./styles.css";

const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
const legalKind =
  pathname === "/kayttoehdot"
    ? "terms"
    : pathname === "/tietosuojaseloste"
      ? "privacy"
      : null;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {legalKind ? (
      <LegalPage kind={legalKind} />
    ) : (
      <Marketplace initialListings={[]} />
    )}
  </StrictMode>,
);
